var React = require('react');

function Timeline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M.91 11.5h5.05v1H.91zM20.81 13.34L22.05 12l-1.24-1.34h1.05L23.09 12l-1.23 1.34z","key":0}),React.createElement("path",{"d":"M7.13 13.81c-.9 0-1.64-.8-1.64-1.77 0-.98.74-1.77 1.64-1.77.9 0 1.64.8 1.64 1.77 0 .98-.74 1.77-1.64 1.77zm0-2.54c-.4 0-.71.34-.71.77s.32.77.71.77c.4 0 .71-.35.71-.77s-.32-.77-.71-.77zM16.59 13.81c-.9 0-1.64-.8-1.64-1.77 0-.98.73-1.77 1.64-1.77.9 0 1.63.8 1.63 1.77 0 .98-.73 1.77-1.63 1.77zm0-2.54c-.4 0-.72.34-.72.77s.32.77.72.77.7-.35.7-.77-.31-.77-.7-.77z","key":1}),React.createElement("path",{"opacity":".5","d":"M20.76 18.78H12.4c-.74 0-1.33-.65-1.33-1.45v-.63c0-.8.6-1.44 1.33-1.44h2.99l1.2-2.23 1.2 2.23h2.98c.35 0 .69.15.94.42.25.28.39.64.39 1.02v.63c0 .8-.6 1.45-1.34 1.45zm-8.36-2.52c-.23 0-.41.2-.41.44v.63c0 .25.18.45.41.45h8.37c.22 0 .4-.2.4-.45v-.63a.45.45 0 0 0-.11-.31.4.4 0 0 0-.3-.13h-3.5L16.6 15l-.67 1.25H12.4zM2.56 9h3.53l.52.94.51.95.51-.95.52-.95h3.55c.53 0 .96-.47.96-1.04v-.69c0-.57-.43-1.02-.96-1.02H2.56c-.53 0-.95.45-.95 1.02v.7c0 .56.42 1.03.95 1.03z","key":2}),React.createElement("path",{"d":"M8.3 11.5h7.11v1H8.3zM17.76 11.5h4.29v1h-4.29z","key":3})]);
}

Timeline.displayName = "Timeline";

Timeline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Timeline;

Timeline.default = Timeline;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Timeline.svg
// module id = 653
// module chunks = 168707334958949